/* MM goal bar – display only (Gratisversand / kleine / Research Box). Revenue Lift Operator 2026-10-06 */
(() => {
  if (window.customElements.get('mm-goal-bar')) return;
  const last = (window.__mmGoalBarLast = window.__mmGoalBarLast || {});
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const fmt = (cents, format) => {
    const f = format || '€{{amount_with_comma_separator}}';
    const delim = (n, prec, t, d) => {
      const s = (n / 100).toFixed(prec).split('.');
      return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (s[1] ? d + s[1] : '');
    };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount': return delim(cents, 2, ',', '.');
        case 'amount_no_decimals': return delim(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(cents, 2, "'", '.');
        case 'amount_with_space_separator': return delim(cents, 2, ' ', ',');
        default: return delim(cents, 2, '.', ',');
      }
    });
  };

  class MmGoalBar extends HTMLElement {
    connectedCallback() {
      const d = this.dataset;
      this.ctx = d.context || 'cart';
      const rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
      this.goals = (d.goals || '10000,15000,40000').split(',').map((g) => Math.round(parseInt(g, 10) * rate));
      this.base = parseInt(d.base, 10) || 0;
      this.unit = parseInt(d.unit, 10) || 0;
      this.variantId = d.variant ? parseInt(d.variant, 10) : null;
      this.inCart = d.inCart === 'true';
      this.qty = 1;
      this.money = d.moneyFormat;
      this.variantOk = !this.hasAttribute('hidden');
      this.shipOk = true;
      this.msg = this.querySelector('.mm-gb__msg');
      this.track = this.querySelector('.mm-gb__track');
      this.fills = { proj: this.querySelector('.mm-gb__fill--proj'), base: this.querySelector('.mm-gb__fill--base') };
      this.dots = this.querySelectorAll('.mm-gb__dot');
      this.labels = this.querySelectorAll('.mm-gb__label');
      this.ac = new AbortController();
      const o = { signal: this.ac.signal };

      // re-rendered (e.g. cart drawer refresh): continue from the previous state instead of replaying the intro
      if (last[this.ctx] && !reduce.matches) {
        this.classList.add('mm-gb--noanim');
        const tgt = { proj: this.fills.proj.style.getPropertyValue('--p'), base: this.fills.base.style.getPropertyValue('--p') };
        this.fills.proj.style.setProperty('--p', last[this.ctx].proj);
        this.fills.base.style.setProperty('--p', last[this.ctx].base);
        void this.offsetWidth;
        requestAnimationFrame(() => { this.fills.proj.style.setProperty('--p', tgt.proj); this.fills.base.style.setProperty('--p', tgt.base); });
      }
      this._remember();

      document.addEventListener('cart:change', (e) => e.detail && e.detail.cart ? this._fromCart(e.detail.cart) : this._fetch(), o);
      document.addEventListener('cart:refresh', () => this._fetch(), o);
      window.addEventListener('pageshow', (e) => { if (e.persisted) this._fetch(); }, o);

      if (this.ctx === 'product') {
        const form = d.form ? document.getElementById(d.form) : this.closest('form');
        this.formId = d.form || (form && form.getAttribute('id')); // note: form.id can resolve to the input named "id"
        if (form) form.addEventListener('variant:change', (e) => this._onVariant(e.detail && e.detail.variant), o);
        const onQty = (e) => {
          const t = e.target;
          if (!t || t.name !== 'quantity') return;
          if ((t.getAttribute('form') || (t.form && t.form.getAttribute('id'))) !== this.formId) return;
          this.qty = Math.max(1, parseInt(t.value, 10) || 1);
          this.render();
        };
        document.addEventListener('change', onQty, o);
        document.addEventListener('input', onQty, o);
        const q = this.formId && document.querySelector(`[name="quantity"][form="${this.formId}"]`);
        if (q) this.qty = Math.max(1, parseInt(q.value, 10) || 1);
        this._fetch(); // page may come from cache: confirm the cart once
      }
    }

    disconnectedCallback() { this.ac && this.ac.abort(); }

    async _fetch() {
      try {
        const r = await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart.js`, { headers: { Accept: 'application/json' } });
        if (r.ok) this._fromCart(await r.json());
      } catch (_) { /* keep the server-rendered state */ }
    }

    _fromCart(cart) {
      this.base = cart.total_price || 0;
      this.inCart = !!(this.variantId && (cart.items || []).some((i) => i.variant_id === this.variantId));
      if (this.ctx === 'cart') this.shipOk = cart.item_count > 0 && cart.requires_shipping !== false;
      this.render();
    }

    _onVariant(v) {
      if (!v) { this.variantOk = false; this.render(); return; }
      this.variantId = v.id;
      this.unit = v.price;
      this.variantOk = v.available && v.requires_shipping !== false;
      this._fetch();
    }

    _p(v) {
      const [a, b, c] = this.goals;
      if (v >= c) return 1;
      if (v >= b) return (2 + (v - b) / (c - b)) / 3;
      if (v >= a) return (1 + (v - a) / (b - a)) / 3;
      return Math.max(0, v / a) / 3;
    }

    _remember() {
      last[this.ctx] = { proj: this.fills.proj.style.getPropertyValue('--p'), base: this.fills.base.style.getPropertyValue('--p') };
    }

    render() {
      const product = this.ctx === 'product';
      const visible = product ? this.variantOk : this.shipOk;
      this.toggleAttribute('hidden', !visible);
      if (!visible) return;
      const prefixed = product && !this.inCart;
      const add = prefixed ? this.unit * this.qty : 0;
      const proj = this.base + add;
      const [a, b, c] = this.goals;
      const m = (x) => `<strong>${fmt(x, this.money)}</strong>`;
      const tier = (v) => (v >= c ? 3 : v >= b ? 2 : v >= a ? 1 : 0);
      const tp = tier(proj);
      const jump = prefixed && tp > tier(this.base);
      let t;
      if (tp === 3) t = jump ? 'Mit diesem Artikel hast du alle Extras freigeschaltet.' : 'Du hast alle Extras freigeschaltet.';
      else {
        const next = [a, b, c][tp];
        const goal = ['zum Gratisversand', 'zur kleinen Überraschung', 'zur Research Box'][tp];
        const lead = ['', 'Mit diesem Artikel ist dein Versand gratis.', 'Mit diesem Artikel ist die kleine Überraschung dabei.'][tp];
        const leadC = ['', 'Dein Versand ist gratis.', 'Die kleine Überraschung ist dabei.'][tp];
        if (jump) t = `${lead} Noch ${m(next - proj)} bis ${goal}.`;
        else if (prefixed) t = `Mit diesem Artikel fehlen dir noch ${m(next - proj)} bis ${goal}.`;
        else t = `${leadC ? leadC + ' ' : ''}Noch ${m(next - proj)} bis ${goal}.`;
      }
      if (this.msg.innerHTML !== t) this.msg.innerHTML = t;
      this.fills.proj.style.setProperty('--p', this._p(proj).toFixed(4));
      this.fills.base.style.setProperty('--p', this._p(this.base).toFixed(4));
      this.track.setAttribute('aria-valuenow', Math.floor(proj / 100));
      this.goals.forEach((g, i) => {
        const st = this.base >= g ? 'is-reached' : proj >= g ? 'is-near' : '';
        [this.dots[i], this.labels[i]].forEach((el) => { if (!el) return; el.classList.remove('is-reached', 'is-near'); if (st) el.classList.add(st); });
      });
      this._remember();
    }
  }
  window.customElements.define('mm-goal-bar', MmGoalBar);
})();
